/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('./common')

const app = require('appSrc/app/app');
const routerHub = require('appSrc/router/router');
const router = require('./router.js');
const spinner = require('src/common/utils/spinner');

router.map(routerHub);

router.beforeEach(function(transition) {
    spinner.start();
   
    //清空 jquery 和 bootstrap 的插件
    $('.datetimepicker').remove();
    let token = window.localStorage.getItem('appBackToken');
    if (!token && transition.to.matched[0].handler.path == '/page') {
        router.go({
            path: '/login'
        })
    }

    transition.next();
});

router.afterEach(function(transition) {
    document.title = transition.to.title ? transition.to.title : '欢迎您使用猛犸电动社区管理系统！';

    spinner.end();
});

router.start(app, '#app');



// WEBPACK FOOTER //
// ./src/appBackend/main.js